import { ACTION_TYPES, useConveniosDispatch, useConveniosState } from "./convenios-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { IConvenioPagedRequest } from "models/request/convenio-paged-request";
import { downloadFile } from "utils/download-file";

export const useConveniosController = () => {
    const conveniosDispatch = useConveniosDispatch();
    const { convenioPagedRequest } = useConveniosState();

    async function exportConvenios(format: string) {
        const file = await MunicipalPortalAAppService.exportConvenios(convenioPagedRequest, format);
        downloadFile(file);
    }

    async function onInit() {
        let request = { page: 0, pageSize: 10 } as IConvenioPagedRequest;

        conveniosDispatch({ type: ACTION_TYPES.setConvenioPagedRequest, payload: request });
        conveniosDispatch({ type: ACTION_TYPES.setLoading, payload: true });

        await listConvenios(request);
        await loadLookups();

        conveniosDispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    async function loadLookups() {
        try {
            const [situacoes, ultimaAtualizacao] = await Promise.all([
                MunicipalPortalAAppService.listSituacoesConvenio(),
                MunicipalPortalAAppService.getConveniosUltimaAtualizacao()
            ]);
            conveniosDispatch({ type: ACTION_TYPES.setSituacoes, payload: situacoes });
            conveniosDispatch({ type: ACTION_TYPES.setUltimaAtualizacao, payload: ultimaAtualizacao?.dtaUltimaAtualizacao ?? null });
        } catch (error) {
            console.log(error);
        }
    }

    async function listConvenios(request: IConvenioPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                conveniosDispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            conveniosDispatch({ type: ACTION_TYPES.setError, payload: null });

            const [convenios, totais] = await Promise.all([
                MunicipalPortalAAppService.listConvenios(request),
                MunicipalPortalAAppService.getConveniosTotais({
                    term: request.term,
                    idSituacaoConvenio: request.idSituacaoConvenio,
                    dataInicio: request.dataInicio,
                    dataFim: request.dataFim,
                }),
            ]);

            conveniosDispatch({ type: ACTION_TYPES.setConvenios, payload: convenios });
            conveniosDispatch({ type: ACTION_TYPES.setTotais, payload: totais });
        } catch (error) {
            console.log(error);
            conveniosDispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar os convênios. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                conveniosDispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChange = (e: any) => {
        let updated = { ...convenioPagedRequest };

        if (e.target.name === "text-field-term") {
            updated.term = e.target.value;
            if (!updated.term) {
                (async () => await listConvenios({ ...updated, page: 0 }, true))();
            }
        } else if (e.target.name === "select-situacao-id") {
            updated.idSituacaoConvenio = e.target.value;
        } else if (e.target.name === "date-field-inicio") {
            updated.dataInicio = e.target.value;
        } else if (e.target.name === "date-field-fim") {
            updated.dataFim = e.target.value;
        } else if (e.target.name === "select-order-direction") {
            updated.orderDirection = e.target.value;
            (async () => await listConvenios({ ...updated, page: 0 }, true))();
        }

        conveniosDispatch({ type: ACTION_TYPES.setConvenioPagedRequest, payload: updated });
    };

    return { listConvenios, handleOnChange, onInit, exportConvenios };
}
